import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import * as R from 'ramda';

import { SvgIcon } from '../../../svg-icon';

import {
  CounterItem,
  ImageWrapper,
  StyledDivider,
  CountersWrapper,
} from './styled-components';
import { theme } from '../../../../styles';
import LabelPopover from './label-popover/';
import { ROUTES } from '../../../../routes';
import { Tooltip } from '../../../popovers/tooltip';

export const Counters = React.memo(({
  _id,
  style,
  tasks,
  labels,
  meetingNotes,
  comments,
}) => {
  const {
    mainDark,
    backgroundDarkGray,
  } = theme.colors;

  const tasksColor = R.pathOr(0, ['length'], tasks) > 0 ? mainDark : backgroundDarkGray;
  const commentsColor = R.pathOr(0, ['length'], comments) > 0 ? mainDark : backgroundDarkGray;
  const notesColor = R.pathOr(0, ['length'], meetingNotes) > 0 ? mainDark : backgroundDarkGray;

  return (
    <CountersWrapper
      style={style}
      onClick={(e) => { e.stopPropagation(); }}
    >
      {labels.length !== 0 && (
        <Fragment>
          <ImageWrapper className="label-wrapper" style={{ margin: 'unset' }}>
            <LabelPopover color={mainDark} labels={labels} />
          </ImageWrapper>
          <StyledDivider type="vertical" />
        </Fragment>
      )}
      <Tooltip
        placement="bottom"
        title="Meeting notes"
      >
        <CounterItem
          target="_blank"
          href={`${ROUTES.REQUEST}?id=${_id}&tab=notes`}
          color={notesColor}
        >
          {R.pathOr(0, ['length'], meetingNotes)}
          <ImageWrapper >
            <SvgIcon color={notesColor} type="notes" fillOpacity={1} />
          </ImageWrapper>
        </CounterItem>
      </Tooltip>

      <StyledDivider type="vertical" />

      <Tooltip
        title="Comments"
        placement="bottom"
      >
        <CounterItem
          target="_blank"
          href={`${ROUTES.REQUEST}?id=${_id}&tab=comments`}
          color={commentsColor}
        >
          {R.pathOr(0, ['length'], comments)}
          <ImageWrapper >
            <SvgIcon color={commentsColor} type="comment" fillOpacity={1} />
          </ImageWrapper>
        </CounterItem>
      </Tooltip>

      <StyledDivider type="vertical" />

      <Tooltip
        title="Request tasks"
        placement="bottom"
      >
        <CounterItem
          target="_blank"
          href={`${ROUTES.REQUEST}?id=${_id}&tab=tasks`}
          color={tasksColor}
        >
          {R.pathOr(0, ['length'], tasks)}
          <ImageWrapper >
            <SvgIcon color={tasksColor} type="tasks" fillOpacity={1} />
          </ImageWrapper>
        </CounterItem>
      </Tooltip>
    </CountersWrapper>
  );
});

Counters.propTypes = {
  tasks: PropTypes.array,
  style: PropTypes.object,
  labels: PropTypes.array,
  comments: PropTypes.array,
  meetingNotes: PropTypes.array,
  _id: PropTypes.string.isRequired,
};

Counters.defaultProps = {
  style: {},
  tasks: [],
  labels: [],
  comments: [],
  meetingNotes: [],
};



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/counters/index.js